import { TimeUnit } from '../../utils';
import { ProcessingNode } from '../ProcessingNode';
/**
 * Frame delay node to delay pushing of frames.
 * @category Flow shape
 */
export class FrameDelayNode extends ProcessingNode {
  constructor(timeout, timeoutUnit) {
    super();
    this._timeout = timeout;
    this._timeoutUnit = timeoutUnit;
  }
  process(frame) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(frame);
      }, this._timeoutUnit.convert(this._timeout, TimeUnit.MILLISECOND));
    });
  }
}